export default "__VITE_ASSET__DQDPGvbo__"